const formatDepartment = (department: { number: any; name: any }) =>
  [department.number, department.name].filter(Boolean).join(" ");

export default formatDepartment;
